import React, { FC, useEffect, useState, useCallback } from "react";
import style from "../../../styles/tileDownloaderStyle";
import { useMap } from "../../../App";
import { DownloadState } from "../MapDownloadPage";

function useMapViewState(map: ol.Map) {
  const [zoom, setZoom] = useState<number>(map.getView().getZoom());

  useEffect(() => {
    const changeEventKey = map.getView().on("change:resolution", () => {
      setZoom(map.getView().getZoom());
    });

    return () => ol.Observable.unByKey(changeEventKey);
  });

  return { zoom };
}

const MapDownloadStep2: FC<{ state: DownloadState; onNext: (values: Partial<DownloadState>) => void; onBack: () => void }> = ({
  state,
  onNext,
  onBack,
}) => {
  const map = useMap()!;

  const { zoom: exactZoom } = useMapViewState(map);
  const currentZoom = Math.round(exactZoom);

  const endZoom = Math.max(currentZoom, state.startZoom!);

  const createExtentLayer = useCallback((extent: ol.Extent) => {
    const style = new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: "rgba(241,51,206,0.8)",
        width: 8,
      }),
    });

    const polygon = ol.geom.Polygon.fromExtent(extent);
    const feature = new ol.Feature(polygon);

    const vectorSource = new ol.source.Vector();
    vectorSource.addFeature(feature);

    return new ol.layer.Vector({
      source: vectorSource,
      style: style,
      name: "PIANO_EXTENT_LAYER",
    } as any);
  }, []);
  const removeExtentLayer = useCallback(() => {
    map
      .getLayers()
      .getArray()
      .filter((layer) => layer.get("name") === "PIANO_EXTENT_LAYER")
      .forEach((layer) => {
        map.removeLayer(layer);
      });
  }, [map]);

  useEffect(() => {
    removeExtentLayer();
    map.addLayer(createExtentLayer(state.extent!));
    return () => removeExtentLayer();
  }, [createExtentLayer, map, removeExtentLayer, state.extent]);

  const buttonNextClick = useCallback(() => {
    onNext({ endZoom });
  }, [onNext, endZoom]);

  const buttonZoomInClick = useCallback(() => {
    map.getView().setZoom(currentZoom + 1);
  }, [currentZoom, map]);
  const buttonZoomOutClick = useCallback(() => {
    map.getView().setZoom(currentZoom - 1);
  }, [currentZoom, map]);

  const css = style;

  return (
    <div>
      <p>Select end zoom level</p>

      <h1 style={{ fontSize: 35 }}>
        <i className="fa fa-minus-square pull-left" onClick={buttonZoomOutClick}></i> {state.startZoom} to {endZoom}{" "}
        <i className="fa fa-plus-square pull-right" onClick={buttonZoomInClick}></i>
      </h1>
      <div style={{ marginTop: 30 }}>
        <button onClick={onBack} className="button  button-fill pull-left" style={css.buttonConfirm}>
          Back
        </button>
        <button onClick={buttonNextClick} className="button  button-fill pull-right" style={css.buttonConfirm}>
          Next
        </button>
      </div>
    </div>
  );
};

export default MapDownloadStep2;
